document.addEventListener('DOMContentLoaded', function () {
  var popupOpener = document.querySelector('.product-popup-modal__opener');
  var fallbackLink = document.querySelector('a.product-popup-modal__button.link.no-js');
  var fieldset = document.querySelector('fieldset.product-form__input');

  if (popupOpener && fieldset) {
    fieldset.style.position = 'relative';
    fieldset.appendChild(popupOpener);
  }
  if (fallbackLink && fieldset) {
    fieldset.appendChild(fallbackLink);
  }
});